
export interface Currency {
  id: number;
  name: string;
    isoCode: string;
  currentCurrencyExchange?: CurrencyExchange;
  countryFlag?: string;
  modifiedOn?: string;
}

export interface CurrencyExchange {
  id: number;
  price: number;
  baseRate: number;
  startDate: Date;
  currencyId: number;
}
